<template>
  <div>
    <b-form>
      <b-form-group
        label="舊密碼"
        label-for="old-password"
        class="required-icon-star"
      >
        <b-form-input
          id="old-password"
          v-model="form.old_password"
          :state="verifyOldPassword"
          :title="'輸入格式有誤'"
          type="password"
          required
          placeholder=""
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="新密碼"
        label-for="new-password"
        class="required-icon-star"
      >
        <b-form-input
          id="new-password"
          v-model="form.password"
          :state="verifyNewPassword"
          :title="'輸入格式有誤'"
          type="password"
          required
          placeholder="密碼長度需大於或等於 8"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="確認新密碼"
        label-for="confirm-password"
        class="required-icon-star"
      >
        <b-form-input
          id="confirm-password"
          v-model="form.password_confirmation"
          :state="verifyConfirmPassword"
          :title="'輸入格式有誤'"
          type="password"
          required
          placeholder="密碼長度需大於或等於 8"
        ></b-form-input>
      </b-form-group>
    </b-form>
    <div class="text-right">
      <b-button @click="verifyForm" class="mr-3" type="submit" variant="primary"
        >修改</b-button
      >
      <b-button @click="cancel" type="submit" variant="dark">取消</b-button>
    </div>

    <!-- modal -->
    <b-modal ref="update-password">
      <p class="text-center">是否修改密碼？</p>
      <template v-slot:modal-footer>
        <div class="text-center">
          <b-button @click="submit" class="mr-3" type="button" variant="primary"
            >送出</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import mixinsVerify from "@/utility/mixinsVerify.js";
export default {
  data() {
    return {
      form: {
        old_password: "",
        password: "",
        password_confirmation: ""
      }
    };
  },
  mixins: [mixinsVerify],
  methods: {
    verifyForm() {
      this.$refs["update-password"].hide();
      this.verifyOldPassword =
        this.hasValue(this.form.old_password) === null
          ? this.passwordRegexp(this.form.old_password)
          : false;
      this.verifyNewPassword =
        this.hasValue(this.form.password) === null
          ? this.passwordRegexp(this.form.password)
          : false;
      this.verifyConfirmPassword =
        this.hasValue(this.form.password_confirmation) === null
          ? this.passwordRegexp(this.form.password_confirmation)
          : false;

      if (
        this.verifyOldPassword === false ||
        this.verifyNewPassword === false ||
        this.verifyConfirmPassword === false
      ) {
        return;
      } else if (
        this.isSameInPassword(
          this.form.password,
          this.form.password_confirmation
        ) === false
      ) {
        this.verifyConfirmPassword = false;
        alert("請檢查「確認新密碼」欄位，與「新密碼」欄位不相同");
      } else this.$refs["update-password"].show();
    },
    submit() {
      this.$refs["update-password"].hide();
      this.$store
        .dispatch("updateUserPassword", this.form)
        .then(() => {
          alert("修改成功，系統自動重新登入");
          this.reLogin();
        })
        .catch(e => {
          if (e.status === 422) {
            this.$refs["update-password"].hide();
            this.verifyOldPassword = false;
            alert("密碼錯誤");
          }
        });
    },
    reLogin() {
      const loginData = {
        account: this.$store.getters.loggedInInfo.account,
        password: this.form.password
      };
      this.$store.dispatch("FETCH_TOKEN", loginData).then(() => {
        this.$router.push({ path: "/stock/2330/report-year" });
      });
    },
    cancel() {
      this.verifyOldPassword = null;
      this.verifyNewPassword = null;
      this.verifyConfirmPassword = null;
      const initForm = {
        old_password: "",
        password: "",
        password_confirmation: ""
      };
      this.form = { ...initForm };
    }
  }
};
</script>

<style lang="scss" scoped></style>
